import type { IMosaicTocExpanded } from "./interface";
import { MosaicTocSectionClass } from "./MosaicTocSectionClass";
import { tocSort } from "./tocSort";

/**
 * Sorts ToC items by display number and rewrites their persisted order.
 *
 * @param state - The current expanded ToC state.
 * @returns The updated ToC state after sorting items.
 */
export const toc_sortToc = (state: IMosaicTocExpanded): IMosaicTocExpanded => {
  const newState: IMosaicTocExpanded = { ...state };

  newState.tocItems = newState.tocItems.sort((first, second) =>
    tocSort(first.tocNumber, second.tocNumber),
  );
  newState.tocItems.forEach((item, index) => {
    if (item.tocOrder !== index) {
      if (item instanceof MosaicTocSectionClass) {
        item.update({ id: item.id, saved: false, tocOrder: index });
      } else {
        item.tocOrder = index;
        item.changed = true;
        item.inError = false;
      }
    }
  });
  newState.saving = true;

  return newState;
};
